export default __webpack_public_path__ + "static/how-we-are-dda565a4372807b415303218f9a2c02b.png";